import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=22b6056e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b6056e')) {
      api.createRecord('22b6056e', component.options)
    } else {
      api.reload('22b6056e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=22b6056e&", function () {
      api.rerender('22b6056e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FPykQaH1j6JR/JS/videoIframe.vue"
export default component.exports